import { render, staticRenderFns } from "./TgDownloadApp.vue?vue&type=template&id=74b7613a&"
import script from "./TgDownloadApp.vue?vue&type=script&lang=js&"
export * from "./TgDownloadApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports